<script>
import { Pie } from 'vue-chartjs'

const colors = [
  '#1957CD',
  '#0F347B',
  '#46ADE3',
  '#1895A7',
  '#A5E3ED',
  '#44CEA5',
  '#297C63',
  '#AEE0C6',
  '#532C95',
  '#9E9BF0',
  '#6F0C4E',
  '#B2127C',
  '#E1AFEF',
  '#EC3240',
  '#262F35',
  '#A8ACAE',
  '#1957CD',
  '#0F347B',
  '#46ADE3',
  '#1895A7',
  '#A5E3ED',
  '#44CEA5',
  '#297C63',
  '#AEE0C6',
  '#532C95',
  '#9E9BF0',
  '#6F0C4E',
  '#B2127C',
  '#E1AFEF',
  '#EC3240',
  '#262F35',
  '#A8ACAE'
]

const LIMIT = 15
let maxAge = 0
let ageIndices = {}
let maxAgeLabels = []

export default {
  extends: Pie,
  props: ['height', 'apiData', 'chartName', 'valueField', 'groupedBy'],
  computed: {
    chartData: function () {
      return this.values
    },
    labels: function () {
      const apiLabels = this._.map(this.apiData, 'demographic')
      let labels = []

      _.forEach(apiLabels, (l, id) => {
        if (l === '' || l === null) {
          labels.push('Not Specified')
        } else {
          labels.push(l)
        }
      })

      // If grouped by age, display data by age groups
      if (this.groupedBy === 'b_birthdate' &&
        labels.length > LIMIT) {
        // Save the order of ages
        ageIndices = {}
        const ages = labels.filter((label, id) => {
          ageIndices[id] = !isNaN(parseInt(label)) ? parseInt(label) : 'Unknown'
          return label !== 'Unknown'
        }).map(label => parseInt(label))
        // Sort ages
        ages.sort((a, b) => a - b)

        // Reset labels to group ages by 5
        labels = labels.includes('Unknown') ? ['Unknown'] : []
        let i = 0
        maxAge = ages[ages.length - 1]
        maxAgeLabels = []
        while (i <= maxAge) {
          labels.push(`${i} - ${i + 5}`)
          maxAgeLabels.push(i + 5)
          i += 6
        }
      }
      return labels
    },
    values: function () {
      const values = this._.map(this.apiData, this.valueField)
      if (this.groupedBy === 'b_birthdate' &&
        values.length > LIMIT) {
        const groupedValues = []
        const doesNotSpecifiedExist = Object.values(ageIndices).includes('Unknown')
        groupedValues.length = doesNotSpecifiedExist ? maxAgeLabels.length + 1 : maxAgeLabels.length
        groupedValues.fill(0)
        for (let i = 0; i < values.length; i++) {
          const age = ageIndices[i]
          // Find age that it fits into
          if (age === 'Unknown') {
            groupedValues[0] = values[i]
            continue
          }
          for (let j = 0; j < maxAgeLabels.length; j++) {
            if (age <= maxAgeLabels[j]) {
              if (doesNotSpecifiedExist) {
                groupedValues[j + 1] += values[i]
              } else {
                groupedValues[j] += values[i]
              }
              break
            }
          }
        }
        return groupedValues
      }
      return values
    }
  },
  methods: {
    renderPieChart: function () {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.chartName,
              backgroundColor: colors,
              data: this.chartData,
              borderWidth: 0,
              hoverBorderWidth: 0
            }
          ]
        },
        {
          responsive: false,
          maintainAspectRatio: true,
          aspectRatio: 1,
          cutoutPercentage: 0,
          legend: {
            display: false
            // position: 'bottom',
            // align: 'center',
            // labels: {
            //   boxWidth: 24, // Width of colored box
            //   usePointStyle: true // Changes square box to circle/line
            //   // padding: 32
            // }
          }
        }
      )
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }

      this.renderPieChart()
    }
  },
  mounted () {
    this.renderPieChart()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/PieChart.vue